import React from 'react';
import PropTypes from 'prop-types';

import { Formik, Form as FormikForm } from 'formik';
import NiceLogo from '../../assets/logos/NiceLogo.png';
import NInput from '../inputs/NInput';
import NButton from '../inputs/NButton';
import { loginValidation } from '../../validations/validation';

function Login(props) {
  const { onSubmit, errorMessage, isLoading } = props;

  return (
    <div className='text-left'>
      <Formik
        initialValues={{ userName: '', mailOTP: false }}
        validationSchema={loginValidation}
        onSubmit={(values, formikBag) => {
          onSubmit(values, formikBag);
        }}
        enableReinitialize
      >
        {({ touched, values, errors, handleSubmit, handleChange, handleBlur }) => (
          <FormikForm autoComplete='off' onSubmit={handleSubmit}>
            <div className='mb-10'>
              <img src={NiceLogo} alt='NiceLogo' />
            </div>
            <div className='mb-10'>
              <h4 className='mb-2.5 text-2xl font-semibold text-black'>Log in</h4>
              <p className='text-xs font-normal text-black'>
                Welcome back! Please enter your details
              </p>
            </div>
            <div className='mb-10'>
              <div className='relative'>
                <NInput
                  name='userName'
                  value={values.userName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={(errors.userName && touched.userName) || errorMessage}
                  helperText={
                    errors.userName && touched.userName ? errors.userName : '' || errorMessage
                  }
                  className='w-full'
                  label='Email or Phone number'
                  placeholder='Enter your email or Phone number'
                  type='text'
                />
              </div>
            </div>
            <div className='mb-5'>
              <p className='text-sm text-black'>
                A 6 digit OTP will be sent via SMS or Email to verify your phone number!
              </p>
            </div>
            <div>
              <NButton
                isLoading={isLoading}
                className='!w-full !rounded-[10px] !bg-black !py-[18px]'
                onClick={handleSubmit}
              >
                Continue
              </NButton>
            </div>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
}

Login.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

Login.defaultProps = {
  isLoading: false,
};

export default Login;
